import React, { useState } from 'react';
import BuyerProductForm from './BuyerProductForm';
import SellerProductForm from './SellerProductForm';

function CombinedForm() {
  const [mode, setMode] = useState("buyerForm");

  return (
    <div>
        <div className="sectionWrapper mobileWrapper">
            <div className="flex gap-5 items-center">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="mode"
                  value="buyerForm"
                  checked={mode === "buyerForm"}
                  onChange={() => setMode("buyerForm")}
                  className="accent-green"
                />
                <span className="text-sm font-bold text-green">
                  Request Product
                </span>
              </label>

              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="mode"
                  value="sellerForm"
                  checked={mode === "sellerForm"}
                  onChange={() => setMode("sellerForm")}
                  className="accent-green"
                />
                <span className="text-sm font-bold text-green">
                  Submit Offer
                </span>
              </label>
            </div>
        </div>

        {
            mode === "buyerForm"
            ? <BuyerProductForm />
            : <SellerProductForm />
        }
    </div>
  )
}

export default CombinedForm